import React from "react";
import "./preloader.css";

const Preloader = (props) => {
	return (
		<div className="preloader">
			<span>{ props.text }</span>
			<div className="dot-carrier">
				<div className="dot"></div>
				<div className="dot"></div>
				<div className="dot"></div>
			</div>
		</div>
	);
};

export default Preloader;
